exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".about[data-v-75ce67cc]{padding:60px 12px;max-width:600px;margin:0 auto}", "", {"version":3,"sources":["C:/Users/jusma/Projects/lowco.tv/src/components/home/About.vue"],"names":[],"mappings":"AACA,wBACE,kBAAmB,AACnB,gBAAiB,AACjB,aAAe,CAChB","file":"About.vue","sourcesContent":["\n.about[data-v-75ce67cc] {\n  padding: 60px 12px;\n  max-width: 600px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75ce67cc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/About.vue
// module id = 1099
// module chunks = 2